export enum WebSocketEventType {
    RESERVATION_UPDATED = 'RESERVATION_UPDATED',
    ITEROFILES = 'ITEROFILES',
    CHAT = 'CHAT',
    INQUIRY = 'INQUIRY',
    TRIAGE = 'TRIAGE',
    SURVEYS = 'SURVEYS',
}
